import React, { 
    createContext,
    useContext,
    ReactNode,
} from 'react';

export interface SessionContextValue {
    sessionId?: string;
    enableBot: boolean;
    enableSurvey: boolean;
}

interface SessionProviderProps {
    children: ReactNode;
    value: SessionContextValue;
}

const SessionContext = createContext<SessionContextValue | null>(null);

export const SessionProvider: React.FC<SessionProviderProps> = ({
    children,
    value,
}) => {
    return (
        <SessionContext.Provider value={value}>
            {children}
        </SessionContext.Provider>
    );
};

export const useSessionContext = (): SessionContextValue => {
    const context = useContext(SessionContext);
    if (!context) {
        throw new Error('useSessionContext must be used within a SessionProvider');
    }
    return context;
};
